import { render, staticRenderFns } from "./SaleBusiness.vue?vue&type=template&id=1f1857b8&"
import script from "./SaleBusiness.vue?vue&type=script&lang=js&"
export * from "./SaleBusiness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports